/** Frases do painel amarelo do login e do cadastro (carrossel). */
export const SLIDES_PADRAO = [
    { titulo: 'Seus títulos em um só lugar', subtitulo: 'Inclua, acompanhe e dê baixa sem trocar de sistema.' },
    { titulo: 'Inclusão simples ou em lote', subtitulo: 'Envie um título por vez ou uma planilha inteira.' },
    { titulo: 'Histórico de cada protocolo', subtitulo: 'Toda movimentação fica registrada para consulta.' },
];

/** Itens do checklist de senha — mesmos critérios da regex (?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,} */
export const REQUISITOS_SENHA = [
    { chave: 'len', texto: '8 ou mais caracteres', testa: (v) => v.length >= 8 },
    { chave: 'upper', texto: 'Uma letra maiúscula', testa: (v) => /[A-Z]/.test(v) },
    { chave: 'lower', texto: 'Uma letra minúscula', testa: (v) => /[a-z]/.test(v) },
    { chave: 'num', texto: 'Um número', testa: (v) => /\d/.test(v) },
];

/** Checklist para o template: [{ chave, texto, ok }] */
export function checklistSenha(senha) {
    const v = senha || '';
    return REQUISITOS_SENHA.map(({ chave, texto, testa }) => ({ chave, texto, ok: testa(v) }));
}

export function senhaValida(senha) {
    return checklistSenha(senha).every((r) => r.ok);
}

export function emailValido(email) {
    return /.+@.+\..+/.test(email || '');
}
